const numberFormat = new Intl.NumberFormat('de-DE', {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})
const numberFormatNoFraction = new Intl.NumberFormat('de-DE', {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
})

function _formatCurrency (amount: number, shouldRound = false) {
  if (shouldRound) {
    return numberFormatNoFraction.format(amount / 100) + ' €'
  }
  return numberFormat.format(amount / 100) + ' €'
}

function _formatNumber (value: number, minimumFractionDigits = 0, maximumFractionDigits = minimumFractionDigits) {
  const decimalFormat = new Intl.NumberFormat('de-DE', {
    style: 'decimal',
    minimumFractionDigits,
    maximumFractionDigits
  })
  return decimalFormat.format(value)
}

// TODO: HACK: In e2e tests chromium:headless does not have any other locale than en-US
//  As i18n is not implemented correctly anyway, we overwrite any wrong formatting by hand until fixed properly
// @ts-ignore
const toFixedGermanFormatting = (fn) => (...args) => fn(...args)?.replace('.', ',')
export const formatNumber = toFixedGermanFormatting(_formatNumber)
export const formatCurrency = toFixedGermanFormatting(_formatCurrency)
